import React, { useCallback } from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";

const ChatMessageDeleteModal = (props) => {
  const handleClick = useCallback(() => {
    props.handleClick(props.id);
  }, [props]);
  return (
    <div className={modalStyles.container}>
      <header>
        <h3>チャットを削除します</h3>
      </header>
      <div className={modalStyles.chatMessageDisplay}>
        <div className={modalStyles.chatMessage}>
          <span className={modalStyles.username}>{props.displayName}</span>
          <span className={modalStyles.messageContent}>{props.postDesc}</span>
        </div>
      </div>
      <Button fillWhiteColor fontFixed large onClick={handleClick}>
        削除する
      </Button>
      <Button fontFixed large borderLight onClick={props.modalCloseHandle}>
        閉じる
      </Button>
    </div>
  );
};

export default ChatMessageDeleteModal;
